import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { TranslocoLoader } from "@jsverse/transloco";
import { AppConstants } from "./app/core/constants/app-constants";

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
    private http = inject(HttpClient);

    getTranslation(langPath: string) {
        // return this.http.get(`./assets/i18n/${langPath}.json`);
        return this.http.get<Record<string, any>>(`./assets/i18n/${langPath}.json${AppConstants.version}`);
    }
}
